import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BetHistory from "./components/BetHistory";
import SelectHours from "./components/SelectHours";
import { selectAuth } from "../../redux/auth/selectors";
import { formatNumber } from "../../services/utility/utils";

import "./styles.scss";
import { useTheme } from "../../hook/useThemes";
import { CircularProgress } from "@mui/material";

const { REACT_APP_URL_HXROAPI } = process.env;

export default function HistoryPage() {
  const [betHistory, setBetHistory] = useState([]);
  const [summary, setSummary] = useState<any>({
    totalBet: 0,
    totalWin: 0,
    totalLose: 0,
  });
  const [selectedHour, setSelectedHour] = useState(1);
  const [loading, setLoading] = useState(false);
  const auth = useSelector(selectAuth);
  const { lang, fixed_odds, seriesID } = useTheme();

  const handleGetData = async (seriesID: string) => {
    const searchParams = new URLSearchParams([
      [
        "from_time",
        new Date(Date.now() - selectedHour * 60 * 60 * 1000).toISOString(),
      ],
      ["to_time", new Date().toISOString()],
      ["series_id", seriesID],
    ]);
    await axios
      .get(`${REACT_APP_URL_HXROAPI}/history/bet?${searchParams.toString()}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(({ data }) => {
        const summary = data.reduce(
          (acc, curr) => {
            acc.totalBet += curr.wager;
            if (curr.winning) {
              acc.totalWin += curr.whitelabelPayout;
            } else {
              acc.totalLose += curr.wager;
            }

            return acc;
          },
          { totalBet: 0, totalWin: 0, totalLose: 0 }
        );
        setSummary(summary);
        setBetHistory([...data].reverse());
      })
      .catch((err) => {
        console.error(err);
        setSummary({ totalBet: 0, totalWin: 0, totalLose: 0 });
        setBetHistory([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!seriesID) {
      window.location.reload();
      return;
    }
    if (auth?.token) {
      if (!selectedHour) {
        return;
      }
      setLoading(true);
      handleGetData(seriesID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(auth?.token), selectedHour, seriesID]);

  return (
    <div className="wrapper-history-page">
      <div className="container wrapper-history-content">
        <div className="wrapper-history-header">
          <div className="content-history-title">
            <p className="title-history">
              {lang?.bet_history || "Bet History"}
            </p>
          </div>
          <div className="content-bet-summary">
            {/* <div className="small">Summary</div> */}
            <div className="content-bet-summary-total">
              {lang?.bets || "Bets"}:{" "}
              <span>
                {fixed_odds
                  ? betHistory?.length || 0
                  : formatNumber(summary.totalBet, 2)}
              </span>
            </div>
            <div className="content-bet-summary-total">
              {lang?.win_loss || "Win / Loss"}:{" "}
              <span>
                {summary.totalWin < summary.totalLose ? "-" : ""}$
                {formatNumber(
                  Math.abs(summary.totalWin - summary.totalLose || 0).toFixed(
                    2
                  ),
                  2
                )}
              </span>
            </div>
          </div>
          <div className="header-empty">
            <SelectHours onSelectHours={setSelectedHour} />
          </div>
        </div>
        <div className="content-bet-summary-mobile">
          {/* <div className="small">Summary</div> */}
          <div className="content-bet-summary-total">
            {lang?.bets || "Bets"}:{" "}
            <span>{formatNumber(summary.totalBet, 2)}</span>
          </div>
          <div className="content-bet-summary-total">
            {lang?.win_loss || "Win / Loss"}:{" "}
            <span>
              {summary.totalWin < summary.totalLose ? "-" : ""}$
              {formatNumber(
                Math.abs(summary.totalWin - summary.totalLose || 0).toFixed(2),
                2
              )}
            </span>
          </div>
        </div>
        <div></div>

        <>
          {loading ? (
            <div className="wrap-loading">
              <p>{lang?.loading || "Loading result"}</p>
              <CircularProgress
                size={24}
                className="circular-progress"
                style={{
                  color: "#B3BECE",
                }}
              />
            </div>
          ) : (
            <>
              {!!betHistory?.length && (
                <div className="content-bet-history">
                  {betHistory.map((itm) => (
                    <BetHistory key={itm.id} entry={itm} />
                  ))}
                </div>
              )}

              {!betHistory?.length && (
                <>
                  <div className="content-history-notify-select">
                    {!fixed_odds && (
                      <div
                        className="content-label"
                        dangerouslySetInnerHTML={{
                          __html:
                            (!selectedHour
                              ? lang?.empty_history
                              : lang?.empty_history_selected) ||
                            (!selectedHour
                              ? "Select a period<br/>above to see your<br/>performance."
                              : `No bets were<br/> made in the<br/> period selected.`),
                        }}
                      />
                    )}
                    {fixed_odds && (
                      <div
                        className="content-label-fixed-odd"
                        dangerouslySetInnerHTML={{
                          __html:
                            lang?.empty_history_selected_fixes_odds ||
                            "No bets were placed during the<br/>selected period.",
                        }}
                      />
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </>
      </div>
    </div>
  );
}
